import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { JobDtoType } from '../../index';

export class MeetingBlueprintTriggerJob extends JobConfiguration {
    public readonly type = JobType.MeetingBlueprintTrigger;
    public readonly name = 'Meeting Template Trigger';
    public readonly description = '';
    /**
     * implementation of this config do not have api call so there is no need execute method
     */
    public execute(): Promise<JobDtoType> {
        throw new Error(`${JobType.MeetingBlueprintTrigger} Job execution is not supported.`);
    }
}

export default {
    [JobType.MeetingBlueprintTrigger]: MeetingBlueprintTriggerJob
};
